import app from './app'
import {App} from './App'

export {App};

export default app;
